import React from 'react';
import { cn } from '@hero/web-lib';

export interface AnalyticsMiniTabOption {
  key: string;
  label: string;
  count: number;
}

export interface AnalyticsMiniTabsProps {
  options: AnalyticsMiniTabOption[];
  activeKey: string;
  onChange: (key: string) => void;
}

export const AnalyticsMiniTabs: React.FC<AnalyticsMiniTabsProps> = ({
  options,
  activeKey,
  onChange,
}) => (
  <div className="flex flex-wrap gap-1.5 mt-3">
    {options.map(opt => {
      const isActive = opt.key === activeKey;
      return (
        <button
          key={opt.key}
          type="button"
          onClick={() => onChange(opt.key)}
          className={cn(
            'px-2.5 py-1 rounded-full text-xs font-medium transition-colors',
            isActive
              ? 'bg-primary-100 text-primary-700'
              : 'bg-gray-100 text-gray-500 hover:bg-gray-200',
          )}>
          {opt.label}
          {opt.count > 0 && (
            <span className={cn('ms-1', isActive ? 'text-primary-700' : 'text-gray-400')}>
              ({opt.count.toLocaleString()})
            </span>
          )}
        </button>
      );
    })}
  </div>
);
